import _omit from "lodash/omit";
import Ajv from 'ajv';
import JSONSchemaDraft4Definition from 'ajv/lib/refs/json-schema-draft-04.json';
export var createValidator = function createValidator(jsonSchema) {
  var ajv = new Ajv({
    coerceTypes: true,
    schemaId: 'auto',
    sourceCode: true,
    useDefaults: true
  });
  ajv.addMetaSchema(JSONSchemaDraft4Definition); // We need the validation function to be synchronous in order to use it as a
  // type guard.

  var validate = ajv.compile(_omit(jsonSchema, ['$async']));
  return validate;
};